export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const SIDEBAR = {
  collapsedWidth: 72,
  minWidth: 200,
  maxWidth: 340,
  defaultWidth: 256,
  collapseBelow: 140
};
export const SIDEBAR_STORAGE_KEY = 'ui.sidebar';

export const clampSidebarWidth = (width) => {
  const n = Number(width);
  if (!Number.isFinite(n)) return SIDEBAR.defaultWidth;
  return Math.min(SIDEBAR.maxWidth, Math.max(SIDEBAR.minWidth, Math.round(n)));
};